import {useRef} from "react";

function Input(props) {
    const {
        name = "",
        value = "",
        error = "",
        placeholder,
        type,
        label,
        handleChange,
        onBlur
    } = props;

    const timeOutId = useRef(null)

    const onChange = (e) => {
        timeOutId.current && clearTimeout(timeOutId.current)
        timeOutId.current = setTimeout(() => {
            handleChange(e);
        }, 80)
    }

    return (
        <div className="input-wrapper">
            {!error && label && <label className='label' htmlFor={name}> {label}</label>}
            {error && <label className='label'> {error}</label>}
            <input className={`input ${type || ""}`}
                   type='text'
                   placeholder={placeholder}
                   value={value}
                   onChange={(e) => onChange(e.target.value)}
                   onBlur={onBlur}
                   name={name}
                   autoComplete="off"
            />
        </div>
    )
}

export default Input